import React, { useEffect, useState } from "react";

const NAME_MAX = 30;
const NOTE_MAX = 300;

/**
 * Small modal to edit shift carpool name / note (legacy CarpoolEditComponent parity).
 */
export default function CarpoolEditModal({
  isOpen,
  onClose,
  initialName = "",
  initialNote = "",
  readOnly = false,
  saving = false,
  onSave,
  overlayZClass = "z-[10050]",
}) {
  const [name, setName] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setName(String(initialName ?? "").slice(0, NAME_MAX));
    setNote(String(initialNote ?? "").slice(0, NOTE_MAX));
  }, [isOpen, initialName, initialNote]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (readOnly || saving) return;
    onSave?.({
      carpool_name: name.trim() || null,
      carpool_note: note.trim() || null,
    });
  };

  return (
    <div
      className={`fixed inset-0 ${overlayZClass} flex items-center justify-center bg-black/50 p-4`}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
      role="presentation"
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden"
        role="dialog"
        aria-labelledby="carpool-modal-title"
      >
        <div className="px-4 py-3 border-b border-gray-200">
          <h2 id="carpool-modal-title" className="text-lg font-semibold text-gray-900">
            Carpool Text
          </h2>
        </div>
        <form onSubmit={handleSubmit} className="p-4 space-y-3">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Carpool Name
            </label>
            {readOnly ? (
              <p className="text-sm text-gray-900 border border-gray-100 rounded px-2 py-1.5 bg-gray-50 [overflow-wrap:anywhere] break-all whitespace-pre-wrap">
                {name || "—"}
              </p>
            ) : (
              <input
                type="text"
                maxLength={NAME_MAX}
                value={name}
                onChange={(e) => setName(e.target.value.slice(0, NAME_MAX))}
                className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm"
                placeholder="Carpool Name"
              />
            )}
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Carpool Note
            </label>
            {readOnly ? (
              <p className="text-sm text-gray-900 border border-gray-100 rounded px-2 py-1.5 bg-gray-50 whitespace-pre-wrap [overflow-wrap:anywhere] break-all">
                {note || "—"}
              </p>
            ) : (
              <textarea
                maxLength={NOTE_MAX}
                value={note}
                onChange={(e) => setNote(e.target.value.slice(0, NOTE_MAX))}
                rows={4}
                className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm resize-y"
                placeholder="Carpool Note"
              />
            )}
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={() => onClose?.()}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded hover:bg-gray-50"
            >
              Close
            </button>
            {!readOnly && (
              <button
                type="submit"
                disabled={saving}
                className="px-3 py-1.5 text-sm rounded bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50"
              >
                {saving ? "Saving…" : "Save"}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
